export default __webpack_public_path__ + "static/media/No35.7eff0647.jpg";